// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2S68g","subheader":"ReorderModal_subheader__1K-rQ","listWrap":"ReorderModal_listWrap__9Huwa"};